export const playerContainer = `
<div id="p-container">
	<div id="p-headScoreFoot">
		<div id="p-head">
			<div id="p-head-infoRow">
				<h1 id="p-head-title"></h1>
			</div>
			<div id="p-head-controls">
				<div id="p-head-playAndTempo">
					<div id="p-head-playBtn">
						<img src="{{r}}images/playerScreen/playBtn.png"/>
					</div>
					<div id="p-head-tempo">
						<div id="p-head-tempoButtons">
							<div id="p-head-tempoDownBtn">
								<img src="{{r}}images/playerScreen/downBtn.png"/>
							</div>
							<div id="p-head-tempoUpBtn">
								<img src="{{r}}images/playerScreen/upBtn.png"/>
							</div>
						</div>
						<div id="p-head-tempoText">Tempo: 100%</div>
					</div>
				</div>
				<div id="p-head-rightSection">
					<div id="p-head-settingsAndSongs">
						<div id="p-head-settingsBtn">
							<img src="{{r}}images/playerScreen/settingsBtn.png"/>
						</div>
						<div id="p-head-songsBtn">
							<img src="{{r}}images/playerScreen/songsBtn.png"/>
						</div>
					</div>
				</div>
			</div>
			<div id="p-head-messageRow">
				<div id="p-head-message"></div>
			</div>
		</div>
		<div id="p-score">
			<div id="_sp-fingeringsDiv"></div>
			<div id="p-score-stageDiv">
				<canvas id="stageCanvas"></canvas>
				<div id="percentageDiv" style="display: none;">100%</div>
			</div>
		</div>
	</div>
</div>
`;